import { Platform } from "@angular/cdk/platform";
import {
  APP_INITIALIZER,
  Component,
  Inject,
  Injector,
  LOCALE_ID,
  OnInit,
  Renderer2,
} from "@angular/core";
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
  TranslateStore,
} from "@ngx-translate/core";
//import { colorVariables } from 'src/@vex/components/config-panel/color-variables';
//import { ConfigService } from 'src/@vex/config/config.service';
import { ConfigurationService } from "src/app/shared/services/configuration.service";
import { User } from "src/core/interfaces/user";
import { CommonModule, DOCUMENT, LOCATION_INITIALIZED } from "@angular/common";
//import { LayoutService } from 'src/@vex/services/layout.service';
import { ActivatedRoute, RouterModule } from "@angular/router";
//import { SplashScreenService } from 'src/@vex/services/splash-screen.service';
import {
  MatIconRegistry,
  SafeResourceUrlWithIconOptions,
} from "@angular/material/icon";
import {
  BrowserModule,
  DomSanitizer,
  SafeResourceUrl,
  Title,
} from "@angular/platform-browser";
import { AuthService } from "src/app/shared/services/auth.service";
import { UserService } from "src/app/shared/services/user.service";
//import { VexConfigName } from 'src/@vex/config/config-name.model';
import { Settings } from "luxon";
import { Permissions } from "src/assets/static-data/permissions";
import { VexConfigService } from "src/@vex/config/vex-config.service";
import { VexLayoutService } from "src/@vex/services/vex-layout.service";
import { NavigationService } from "src/app/core/navigation/navigation.service";
import { VexSplashScreenService } from "src/@vex/services/vex-splash-screen.service";
//import { appInitializerFactory } from './app.module';
import { SharedModule } from "src/app/shared/shared.module";
import {
  HTTP_INTERCEPTORS,
  HttpClientModule,
  HttpClient,
} from "@angular/common/http";
import { JwtInterceptor } from "src/core/interceptors/jwt-interceptor";
import { ErrorInterceptor } from "src/core/interceptors/error.interceptor";
import { MatPaginatorIntl } from "@angular/material/paginator";
import { PaginatorI18n } from "src/core/paginator/paginatorI8n";
import { CookieService } from "ngx-cookie-service";
import { HttpLoaderFactory } from "./app.translate-loader";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NavigationLoaderService } from "src/app/core/navigation/navigation-loader.service";
import { VexConfigName } from "src/@vex/config/vex-config.interface";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TransactionsModule } from "./modules/transactions/transactions.module";
import { DriverTripsModule } from "./modules/role-specific/driver/driver-trips/driver-trips.module";
import { TrackVehicleModule } from "./modules/Tracking/track-vehicle/track-vehicle.module";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDateFormats, MatNativeDateModule } from "@angular/material/core";



@Component({
  selector: "vex-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: true,
  imports: [
    SharedModule,
    RouterModule,
    CommonModule,
    HttpClientModule,
    TransactionsModule,
    DriverTripsModule,
    TrackVehicleModule,
    MatDatepickerModule,
    MatNativeDateModule,
  ],

})
export class AppComponent implements OnInit {
  permissions = new Permissions();
  currentUser: User;
  supportLanguages = ["en", "ar"];
  isArabic: boolean;

  constructor(
    private configService: VexConfigService,
    private configurationService: ConfigurationService,
    private translateService: TranslateService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    @Inject(LOCALE_ID) private localeId: string,
    private readonly matIconRegistry: MatIconRegistry,
    private readonly domSanitizer: DomSanitizer,
    private authService: AuthService,
    private titleService: Title,
    private navigationLoaderService: NavigationLoaderService,
  ) {
    this.configurationService.getConfiguration().subscribe((response) => {
      this.titleService.setTitle(
        this.translateService.instant(response.data.appName),
      );
    });

    Settings.defaultLocale = this.localeId;

    //document.documentElement.setAttribute('dir', lang=="en"?'ltr':'rtl'); // Set the direction in the HTML
    
    this.configService.setConfig(VexConfigName.ares)
    this.translateService.get("TOWA.TEXT").subscribe((res)=>{
      this.configService.updateConfig({
        direction:localStorage.getItem('lang')=="ar" || localStorage.getItem('lang')=="ur"?"rtl":"ltr",
        sidenav:{
          imageUrl:'assets/img/logo_transparent.png',
          title:res,
        },
        footer:{
          visible:false,
        }
      });
    })
    
    this.currentUser = authService.currentUserValue;
    document.body.dir = localStorage.getItem('lang')=="ar" || localStorage.getItem('lang')=="ur"?"rtl":"ltr";
  

    this.matIconRegistry.addSvgIconResolver(
      (
        name: string,
        namespace: string,
      ): SafeResourceUrl | SafeResourceUrlWithIconOptions | null => {
        switch (namespace) {
          case "mat":
            return this.domSanitizer.bypassSecurityTrustResourceUrl(
              `assets/img/icons/material-design-icons/two-tone/${name}.svg`,
            );

          case "logo":
            return this.domSanitizer.bypassSecurityTrustResourceUrl(
              `assets/img/icons/logos/${name}.svg`,
            );

          case "flag":
            return this.domSanitizer.bypassSecurityTrustResourceUrl(
              `assets/img/icons/flags/${name}.svg`,
            );
        }
      },
    );
  }
  ngOnInit(): void {
    const translationKeys = [
      'HOME.TEXT',
      'ADMINISTRATION.TEXT',
      'USER-MANAGEMENT.TEXT',
      'USERS.TEXT',
      'ROLES.TEXT',
      'MASTER-DATA.TEXT',
      'CUSTOMERS.TEXT',
      'PRODUCTS.TEXT',
      'TRANSPORTERS.TEXT',
      'VEHICLES.TEXT',
      'FACTORIES.TEXT',
      'DASHBOARD.TEXT',
      'PAGES.TEXT',
      'MODULES.TEXT',
      'TRANSACTIONS.TEXT',
      'SALES_QUOTATIONS.TEXT',
      'LOADING-ORDER.TEXT',
      'SALES_ORDERS.TEXT',
      'SALES_DELIVERIES.TEXT',
      'DRIVER_TRIPS.TEXT',
      'VEHICLES_TRACKING.TEXT',
      "DRIVERS.TEXT",
      "GPS_TRACKING.TEXT",
      "CUSTOMER_ORDERS.TEXT",
      "PURCHASE_ORDERS.TEXT",
      "GROUPS.TEXT",
      "BUSINESS_PARTNERS.TEXT"
    ];
    //this.isArabic = localStorage.getItem("lang") == "ar" ? true : false;
    //this.translateService.setDefaultLang('en'); // Set default language
    this.translateService.get(translationKeys).subscribe((translations) =>
    this.setNavigationItems(translations)
   );
  }

  setNavigationItems(translations){
    const navigation=[
      {
        type: "subheading",
        label: translations["DASHBOARD.TEXT"],
        children: [
          {
            type: "link",
            label: translations["HOME.TEXT"],
            route: "/",
            icon: "mat:insights",
            routerLinkActiveOptions: { exact: true },
          },
        ],
      },
      {
        type: "subheading",
        label: translations["MODULES.TEXT"],
        children: [
          {
            type: "link",
            label: translations["DRIVER_TRIPS.TEXT"],
            route: "/driver-trips",
            icon: "mat:directions_car",
            permission:this.permissions.READ_DRIVER_TRIPS,
            
          },
          {
            type: "dropdown",
            label: translations["ADMINISTRATION.TEXT"],
            icon: "mat:settings",
            permission:this.permissions.READ_ADMINISTRATION,
            children: [
              {
                type: "dropdown",
                label: translations["USER-MANAGEMENT.TEXT"],
                permission:this.permissions.READ_USER_MANAGMENT,
                children: [
                  {
                    type: "link",
                    label: translations["USERS.TEXT"],
                    route: "/user-management/users",
                    permission:this.permissions.READ_USER,
                  },
                  {
                    type: "link",
                    label: translations["ROLES.TEXT"],
                    route: "/role-management/roles",
                    permission:this.permissions.READ_ROLE,
                  },
                ],
              },
            ]},
            {
              type: "dropdown",
              label: translations["MASTER-DATA.TEXT"],
              icon: "mat:dashboard",
              permission:this.permissions.READ_MASTER_DATA,
              children: [
                {
                  type: "dropdown",
                  label: translations["BUSINESS_PARTNERS.TEXT"],
                  icon: "mat:people",
                  permission:this.permissions.READ_CUSTOMER,
                  children: [{
                  type: "link",
                  label: translations["CUSTOMERS.TEXT"],
                  route: "/master-data/customers",
                  permission:this.permissions.READ_CUSTOMER,},{
                    type: "link",
                  label: translations["GROUPS.TEXT"],
                  route: "/master-data/customers-group",
                  permission:this.permissions.READ_CUSTOMER,
                  }]
                },
                {
                  type: "link",
                  label: translations["PRODUCTS.TEXT"],
                  route: "/master-data/products",
                  permission:this.permissions.READ_PRODUCT,
                },
                {
                  type: "link",
                  label: translations["FACTORIES.TEXT"],
                  route: "/master-data/factories",
                  permission:this.permissions.READ_FACTORY,
                },
                {
                  type: "link",
                  label: translations["VEHICLES.TEXT"],
                  route: "/master-data/vehicles",
                  permission:this.permissions.READ_VEHICLE,
                },
                {
                  type: "link",
                  label: translations["TRANSPORTERS.TEXT"],
                  route: "/master-data/transporters",
                  permission: this.permissions.READ_TRANSPORTER,
                },
                {
                  type: "link",
                  label: translations["DRIVERS.TEXT"]/*translations["DRIVERS.TEXT"]*/,
                  route: "/master-data/drivers",
                 permission: this.permissions.READ_DRIVER,
                }
              ],
            },
          {type: "dropdown",
            label: translations["TRANSACTIONS.TEXT"],
            icon: "mat:input",
            permission:this.permissions.READ_TRANSACTION,
            children: [
              {type: "link",
                label: translations["SALES_QUOTATIONS.TEXT"],
                route: "/transactions/sales-quotation",
                permission:this.permissions.READ_SALES_QUOTATION,},
                {
                  type: "link",
                  label: translations["PURCHASE_ORDERS.TEXT"],
                  route: "/transactions/purchase-orders",
                  permission:this.permissions.READ_PURCHASE_ORDER,
                },
                {type: "link",
                  label: translations["SALES_ORDERS.TEXT"],
                  route: "/transactions/sales-orders",
                  permission:this.permissions.READ_SALES_ORDER,},
                 
                {type: "link",
                  label: translations["LOADING-ORDER.TEXT"],
                  route: "/transactions/loading-order",
                  permission:this.permissions.READ_LOADING_ORDER ,},
                  
                    {type: "link",
                      label: translations["SALES_DELIVERIES.TEXT"],
                      route: "/transactions/sales-deliveries",
                      permission:this.permissions.READ_SALES_DELIVERY,},
            ]},
            ,
          {
            type: "link",
            label: translations["GPS_TRACKING.TEXT"],
            route: "/GPS-Tracking",
            icon: "mat:map",
            permission:this.permissions.READ_VEHICLE_TRACKING,
            
          },
        ],
      },
    ];

    const filteredNavigation = this.filterMenuByPermissions(navigation);
    this.navigationLoaderService.setItems(filteredNavigation); // Pass without 'permission'

  }

 // Check if the user has the required permission
 hasPermission(requiredPermission: string): boolean {
  // Flatten the permissions array if it contains nested arrays
  const allPermissions = (this.currentUser?.permissions || []).flat();

  // Check if the required permission exists
  return allPermissions.includes(requiredPermission);
}

// Filter the menu based on user permissions
filterMenuByPermissions(menu: any[]): any[] {
  return menu
    .map(item => {
      // Recursively filter children
      if (item.children) {
        item.children = this.filterMenuByPermissions(item.children);
      }
      // If the user lacks the required permission, return null to filter out the item
      if (item.permission && !this.hasPermission(item.permission)) {
        return null;
      }

      // Return the item if it passes permission check
      return item;
    })
    .filter(item => item !== null); // Remove any null items
}
}
